export const timeType = {
  '-1': '指定日期',
  0: '全部',
  101: '实时',
  102: '天',
  201: '周',
  301: '月',
};

export const timeTypeMapXTitle = {
  101: '时',
  // '-1': '天',
  102: '时',
  201: '天',
  // 301: '月',
};

export const timeTypeMapYTitle = {
  Q1200003: '订单数（个）',
  Q1200001: '金额（元）',
};

// 指标枚举
export const fieldIdMap = {
  q0016: '已结清',
  q0017: '未结清',
  q0018: '总订单',
};

export const timeTypeMap = {
  104: '近15天',
  105: '近30天',
};

export const chunkIdMap = {
  D000001: '需求关闭原因',
  D000003: '未下大货原因',
  D000004: '客户确认结果',
  D000005: '匹配无结果',
  D000006: '需求转化漏斗-下大货',
  D000007: '需求转化漏斗-下剪版',
  D000008: '转化率-下大货',
  D000009: '转化率-下剪版',
  D000010: '终止需求原因',
};

export const chunkJumpMap = {
  D000001: `${window.location.origin}/#/crm/demand-analysis/pie?chunkId=D000001`,
  D000003: `${window.location.origin}/#/crm/demand-analysis/pie?chunkId=D000003`,
  D000004: `${window.location.origin}/#/crm/demand-analysis/pie?chunkId=D000004`,
  D000005: `${window.location.origin}/#/crm/demand-analysis/pie?chunkId=D000005`,
  D000006: `${window.location.origin}/#/crm/demand-analysis/funnel?chunkId=D000006`,
  D000007: `${window.location.origin}/#/crm/demand-analysis/funnel?chunkId=D000007`,
  D000008: `${window.location.origin}/#/crm/demand-analysis/funnel?chunkId=D000008`,
  D000009: `${window.location.origin}/#/crm/demand-analysis/funnel?chunkId=D000009`,
  D000010: `${window.location.origin}/#/crm/demand-analysis/pie?chunkId=D000010`,
};
